/** Query param set on partner-portal embed/style preview iframe URLs only. */
export const EMBED_EDITOR_PREVIEW_PARAM = 'embed_editor_preview';

export function isEmbedEditorPreviewSearch(search: string): boolean {
  return new URLSearchParams(search).get(EMBED_EDITOR_PREVIEW_PARAM) === 'true';
}
